























































































































































import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { getNextAddress } from '@/utils/api.js';

@Component({
  components: {},
})
export default class Locationpicker extends Vue {
  @Prop({ default: '' }) provinceId!: number | string; //省份id
  @Prop({ default: '' }) cityId!: number | string; //市id
  @Prop({ default: '' }) districtId!: number | string; //区id
  @Prop({ default: '' }) streetId!: number | string; //县id

  @Prop({ default: '' }) provinceName: string | undefined; //省份name
  @Prop({ default: '' }) cityName: string | undefined; //市name
  @Prop({ default: '' }) districtName: string | undefined; //区name
  @Prop({ default: '' }) streetName: string | undefined; //县name

  @Prop({ default: '' }) addressIdStr!: string; //返回去一个 4级  地址 拼接的 id字符串  1-2-3-4
  @Prop({ default: '/' }) spliceSymbol!: string; //input  拼接 显示 字符
  @Prop({ default: '-' }) addressIdStrSpliceSymbol!: string; //addressIdStr  拼接 显示 字符
  @Prop({ default: 'left' }) placement!: string; //  位置 暂时 只有 左对齐和 右对齐

  @Prop({ default: true }) isShowClose!: boolean; //是否显示关闭
  @Prop({ default: true }) showCommoAddress!: boolean; //  是否显示 常用收货地址
  @Prop({ default: false }) disabled!: boolean; //  是否显示 常用收货地址

  @Prop({ default: true }) autoWidth!: boolean; //  宽度根据文字 适配

  @Prop({ default: true }) isSetAddressForm!: boolean; //  是否 set AddressForm/sessionStorage

  @Prop({
    default: () => ({
      data: [],
      default: {},
    }),
  })
  commoAddressData: any; //常用收货地址

  @Emit('update:provinceId') updateProvinceId(id: any) {
    return id;
  }
  @Emit('update:cityId') updateCityId(id: any) {
    return id;
  }
  @Emit('update:districtId') updateDistrictId(id: any) {
    return id;
  }
  @Emit('update:streetId') updateStreetId(id: any) {
    return id;
  }

  @Emit('update:provinceName') updateProvinceName(name: string) {
    return name;
  }
  @Emit('update:cityName') updateCityName(name: any) {
    return name;
  }
  @Emit('update:districtName') updateDistrictName(name: any) {
    return name;
  }
  @Emit('update:streetName') updateStreetName(name: string | number) {
    return name;
  }

  @Emit('update:addressIdStr') updateAddressIdStr(name: any) {
    return name;
  }
  commoAddressList: any[] = []; //常用收货地址
  addressLevel: any = 0;
  provinceList: Array<object> = []; //省份list
  cityList: Array<object> = []; //城市list
  districtList: Array<object> = []; //区list
  streetList: Array<object> = []; //县list
  showContent: boolean = false;
  expandCommonAddresses: boolean = false; /// 展开常用地址
  addressName: string = '';
  addressSign: number | string = ''; //标记 选中地址

  @Watch('provinceId', { deep: true, immediate: true }) watchProvinceId(newVal: any, oldVal: any): void {
    if (newVal) {
      this.getCityList(newVal, 1);
    }
  }

  @Watch('cityId', { immediate: true }) watchCityId(newVal: any, oldVal: any): void {
    if (newVal) {
      this.getAreaList(newVal, 2);
    }
  }

  @Watch('districtId', { immediate: true }) watchDistrictId(newVal: any, oldVal: any): void {
    if (newVal) {
      this.getCountyList(newVal, 3);
    }
  }

  @Watch('streetId') watchStreetId(newVal: any, oldVal: any): void {
    if (newVal) {
      this.getFiveAddress(newVal);
    }
  }

  /*
   *@description:'监听收货地址'
   */
  @Watch('commoAddressData', { deep: true, immediate: true })
  watchCommoAddressData(newVal: any): void {
    const { showCommoAddress } = this;
    if (!showCommoAddress) return;
    this.commoAddressList = newVal.data;
    this.getDefaultData(newVal.default);
  }

  get currentValue() {
    const {
      provinceName,
      cityName,
      districtName,
      streetName,
      provinceId,
      cityId,
      districtId,
      streetId,
      spliceSymbol,
      showCommoAddress,
      addressIdStrSpliceSymbol,
    } = this;
    const listName = [provinceName, cityName, districtName, streetName];
    const listId = [provinceId, cityId, districtId, streetId];
    let strInput = listName.filter((item) => item && item !== '0' && item !== 'null').join(spliceSymbol);
    if (showCommoAddress) {
      let addressIdStr = listId.filter((item) => item && item !== 'null').join(addressIdStrSpliceSymbol);
      this.updateAddressIdStr(addressIdStr);
    }
    this.addressName = strInput;
    return strInput;
  }

  //获取第五级 地址信息  解决 第四级  不消失 bug
  getFiveAddress(addressId: number) {
    getNextAddress({ addressId: addressId }).then((res:any) => {
      if (res && res.length === 0) {
        this.close();
        return;
      }
    });
  }

  /*
   *@description:'点击显示地址选择'
   */
  showAddress() {
    const { disabled } = this;
    if (disabled) {
      return;
    }
    this.showContent = true;
  }
  //展开常用地址
  expandClick() {
    this.expandCommonAddresses = !this.expandCommonAddresses;
  }

  setCookieSign(key, val) {
    this.addressSign = val;
  }

  //点击常用地址 更新 选择数据
  updateAddress(data: any = {}) {
    const { provinceId, cityId, districtId, streetId, provinceName, cityName, districtName, streetName } = data;
    this.updateProvinceId(provinceId);
    this.updateCityId(cityId);
    this.updateDistrictId(districtId);
    this.updateStreetId(streetId);
    this.updateProvinceName(provinceName);
    this.updateCityName(cityName);
    this.updateDistrictName(districtName);
    this.updateStreetName(streetName);
  }

  //重新选择重置数据
  reset(level: number) {
    switch (level) {
      case 1:
        this.cityList = [];
        this.districtList = [];
        this.streetList = [];
        this.updateCityId(null);
        this.updateDistrictId(null);
        this.updateStreetId(0);
        this.updateCityName(null);
        this.updateDistrictName(null);
        this.updateStreetName(0);
        break;
      case 2:
        this.districtList = [];
        this.streetList = [];
        this.updateDistrictId(null);
        this.updateStreetId(0);
        this.updateDistrictName(null);
        this.updateStreetName(0);
        break;
      case 3:
        this.streetList = [];
        this.updateStreetId(0);
        this.updateStreetName(0);
        break;
    }
  }

  getAddressLevel(level) {
    this.addressLevel = level;
  }

  close(): void {
    this.showContent = false;
  }

  mouseover(event): void {
    if (this.disabled) {
      return;
    }
    this.showContent = true;
  }
  mouseout(event) {
    this.showContent = false;
  }

  //获取省份
  getProvinceList() {
    getNextAddress().then((res: any) => {
      this.provinceList = res ?? [];
    });
  }
  //获取城市
  getCityList(addressId: number, addressLevel?: number): void {
    if (!addressId) return;
    getNextAddress({ addressId: addressId }).then((res: any) => {
      if (res && res.length === 0) {
        this.close();
        return;
      }
      this.addressLevel = addressLevel;
      this.cityList = res ?? [];
    });
  }

  //获取区
  getAreaList(addressId: number, addressLevel?: number): void {
    if (!addressId) return;
    getNextAddress({ addressId: addressId }).then((res: any) => {
      if (res && res.length === 0) {
        this.close();
        return;
      }
      this.addressLevel = addressLevel;
      this.districtList = res ?? [];
    });
  }

  //获取县
  getCountyList(addressId: number, addressLevel?: number): void {
    if (!addressId) return;
    getNextAddress({ addressId: addressId }).then((res: any) => {
      if (res && res.length === 0) {
        this.close();
        return;
      }
      this.addressLevel = addressLevel;
      this.streetList = res ?? [];
    });
  }

  getSubordinate(data: any = {}) {
    const { provinceId, cityId, districtId, streetId } = this;
    const { addressId, addressLevel, addressName } = data;
    switch (addressLevel) {
      case 1:
        if (provinceId === addressId) {
          this.addressLevel = addressLevel;
          return;
        }
        this.updateProvinceId(addressId); // @Emit("update:")
        this.updateProvinceName(addressName); // @Emit("update:")
        this.reset(addressLevel);
        break;
      case 2:
        if (cityId === addressId) {
          this.addressLevel = addressLevel;
          return;
        }
        this.updateCityId(addressId); // @Emit("update:")
        this.updateCityName(addressName); // @Emit("update:")
        this.reset(addressLevel);
        break;
      case 3:
        if (districtId === addressId) {
          this.showContent = false;
          this.getCountyList(addressId, 3);
        }
        this.updateDistrictId(addressId); // @Emit("update:")
        this.updateDistrictName(addressName); // @Emit("update:")
        this.reset(addressLevel);
        break;
      case 4:
        this.updateStreetId(addressId); // @Emit("update:")
        this.updateStreetName(addressName); // @Emit("update:")
        break;
    }
  }

  //初始化 重置
  resetFields() {
  console.log('初始化 重置------', this.addressLevel);
    this.addressLevel = 0;
    this.cityList = [];
    this.districtList = [];
    this.streetList = [];
  }

  //获取 默认
  getDefaultData(data: any[]): void {
    this.updateAddress(data);
  }

  /*
   *@description:'保存选中地址'
   */
  sessionStorage() {
    const { provinceId, cityId, districtId, streetId, provinceName, cityName, districtName, streetName, isSetAddressForm } = this;
    if (!isSetAddressForm) {
      return;
    }
    const data = {
      provinceId,
      cityId,
      districtId,
      streetId,
      provinceName,
      cityName,
      districtName,
      streetName,
    };
  }

  addEventListenerClick() {
    document.addEventListener('click', (e) => {
      this.showContent = false;
    });
  }

  created() {
    this.getProvinceList();
  }

  mounted() {
    this.addEventListenerClick();
  }
}
